interface Props {
  /** Left position as percentage of the timeline width */
  leftPercent: number;
  /** Height of the parent timeline in pixels */
  height: number;
  /** Text shown in the hover tooltip */
  label: string;
  /** Called when the marker is clicked */
  onClick: () => void;
}

export function DetectionMarker(props: Props) {
  const { leftPercent, height, label, onClick } = props;

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClick();
  };

  return (
    <div
      className="bg-status-red absolute top-0 z-20 w-[2px] cursor-pointer"
      style={{ left: `${leftPercent}%`, height: `${height}px` }}
      title={label}
      onClick={handleClick}
    />
  );
}

export default DetectionMarker;
